import { FilterOptionsState } from "@mui/material";

const normalizeString = (str: string) => {
  return str
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-zA-Z0-9]/g, "")
    .toLowerCase();
};

export const createAutocompleteFilterOptionsFunction = <
  T extends Record<string, any>
>(
  keysToNormalize: (keyof T)[]
) => {
  return (options: T[], state: FilterOptionsState<T>) => {
    const normalizedInput = normalizeString(state.inputValue);

    return options.filter((option) =>
      keysToNormalize.some((key) => {
        const value = option[key] as string | undefined;
        return value && normalizeString(value).includes(normalizedInput);
      })
    );
  };
};
